import ProductCard from "../components/ProductCard";

const ProductsFiltered = (props) => {
  const { filteredProducts, handleProductClick } = props;

  return (
    <section className="filtered">
      <ul className="filtered-list">
        {filteredProducts.map((product) => (
          <li key={product.id}>
            <ProductCard
              product={product}
              handleProductClick={handleProductClick}
              addToCart={props.addToCart}
            />
          </li>
        ))}
      </ul>
      {filteredProducts.length === 0 && (
        <div className="filtered-empty">
          No products match your search. Try a different keyword.
        </div>
      )}
    </section>
  );
};

export default ProductsFiltered;
